document.addEventListener("alpine:init", () => {
    Alpine.data("expandingContent", (config) => ({
        activeCard: 1,
        totalCards: config.totalCards,
        layout: config.layout,
        timer: null,
        containerInView: true,
        lightbox: null,

        async init() {
            this.$nextTick(async () => {
                // Set the CSS variable for total cards
                this.$el.style.setProperty('--total-cards', this.totalCards);

                setTimeout(async () => {
                    document.querySelectorAll(".Expanding__Content-card.video video[autoplay]").forEach(video => {
                        video.removeAttribute("autoplay");
                        video.pause();
                    });

                    this.setActiveCard(this.activeCard);

                    if (!this.lightbox) {
                        const { default: GLightbox } = await import("glightbox");
                        this.lightbox = GLightbox({
                            selector: ".trigger-video-modal",
                            closeOnOutsideClick: true,
                            keyboardNavigation: false,
                            touchNavigation: false,
                            loop: false,
                        });
                    }

                    // Observer for container visibility
                    const containerObserver = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            this.containerInView = entry.isIntersecting;
                        });
                    }, { threshold: 0.1 });

                    containerObserver.observe(this.$el);

                    // Observer for cards to determine which card is in view on mobile
                    const allCards = this.$el.querySelectorAll(".Expanding__Content-card.video");
                    const cardObserver = new IntersectionObserver((entries) => {
                        if (window.innerWidth < 768) {
                            let maxRatio = 0;
                            let visibleCard = null;

                            entries.forEach(entry => {
                                if (entry.intersectionRatio >= 0.5 && entry.intersectionRatio > maxRatio) {
                                    maxRatio = entry.intersectionRatio;
                                    visibleCard = entry.target;
                                }
                            });

                            if (visibleCard) {
                                const cardIndex = Array.from(allCards).indexOf(visibleCard) + 1;
                                this.setActiveCard(cardIndex, { skipScroll: true });
                            }
                        }
                    }, { threshold: [0.5] });

                    allCards.forEach(card => cardObserver.observe(card));
                }, 0);
            });

            if (this.layout === "image_cards") {
                this.startAutoplay();
            }
        },

        startAutoplay() {
            this.stopAutoplay();
            let currentIndex = this.activeCard || 1;
            this.activeCard = currentIndex;

            this.timer = setInterval(() => {
                currentIndex = currentIndex + 1 > this.totalCards ? 1 : currentIndex + 1;
                this.setActiveCard(currentIndex);
            }, 11000);
        },

        stopAutoplay() {
            clearInterval(this.timer);
            this.timer = null;
        },

        setActiveCard(index, { skipScroll = false } = {}) {
            if (index > this.totalCards) {
                index = 1;
            } else if (index < 1) {
                index = this.totalCards;
            }

            const cards = document.querySelectorAll(".Expanding__Content-card.video");
            const previousCardEl = cards[this.activeCard - 1];
            if (previousCardEl) {
                const prevVideo = previousCardEl.querySelector("video");
                if (prevVideo) {
                    prevVideo.pause();
                }
            }

            this.activeCard = index;

            const activeCardEl = cards[this.activeCard - 1];
            if (activeCardEl) {
                const activeVideo = activeCardEl.querySelector("video");
                if (activeVideo) {
                    activeVideo.play();
                }
            }

            if (!skipScroll) {
                this.startAutoplay();
            }

            if (!skipScroll && window.innerWidth < 1024 && this.containerInView) {
                this.$nextTick(() => {
                    const scrollContainer = this.$refs.scrollContainer;
                    const allCards = scrollContainer.querySelectorAll(".Expanding__Content-card");
                    const targetCard = allCards[this.activeCard - 1];

                    if (targetCard && scrollContainer) {
                        const offsetLeft = targetCard.offsetLeft;

                        scrollContainer.scrollTo({
                            left: offsetLeft,
                            behavior: "smooth"
                        });
                    }
                });
            }
        },
    }));
});
